import EventRegistrations from "gatsby-plugin-hfn-profile/components/EventRegistrations";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import PropTypes from "prop-types";
import { styleProp } from "../../assets/data/bandaraRegistration";

const computePnrPageUrl = ({ pnr, eventId }) =>
  `/pnr?pnr=${pnr}&eventId=${eventId}`;

const SpecialEventRegistration = ({ eventId, endDate, data }) => {
  return (
    <div className="special_event_registration" id="register_event">
      <div className="flower_left">
        <StaticImage
          src="../../../static/special-event/5.png"
          alt="banner"
          placeholder="blurred"
        />
      </div>
      <div className="flower_right">
        <StaticImage
          src="../../../static/special-event/4.png"
          alt="banner"
          placeholder="blurred"
        />
      </div>
      <div className="container">
        <div className="row content_wrapper">
          <div className="col-lg-6 col-md-12">
            <p>Dear friends, </p>
            <p>
              I am delighted to invite you all to join the celebrations for the
              95<sup>th</sup> birth anniversary of Pujya Shri Chariji Maharaj
              from 23 to 25 July 2022.
            </p>
            <p>
              Circumstances permitting, we hope to come together at Kanha Shanti
              Vanam for this auspicious event. Please plan your travel
              accordingly, while being flexible enough to revert to a virtual
              celebration if needed. Further details will be announced closer to
              the date.
            </p>
            <p>
              With love and respect,
              <br />
              <span className="author">Kamlesh</span>
            </p>
            <a
              href="https://cdn-prod.heartfulness.org/e-magazines/English/Kanha%20Layout%20Complete%20(3)%20(1).pdf"
              target="_blank"
              rel="noreferrer"
              className="navigation_map"
            >
              Navigation map within Kanha
            </a>
          </div>
          <div className="registerCardWrapper col-lg-5 col-md-12">
            {endDate && (
              <div className="registerCard">
                <h3 className="title">Register to join the celebrations</h3>
                <div className="align_center">
                  <EventRegistrations
                    eventId={eventId}
                    styleProp={styleProp}
                    computePnrPageUrl={computePnrPageUrl}
                    data={data}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

SpecialEventRegistration.propTypes = {
  eventId: PropTypes.string.isRequired,
  endDate: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    reg_starts: PropTypes.string,
    reg_ends: PropTypes.string,
    end_datetime: PropTypes.string,
  }).isRequired,
};

export default SpecialEventRegistration;
